
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const nextLng = i18n.language === 'en' ? 'ja' : 'en';
    i18n.changeLanguage(nextLng);
  };

  return (
    <header className="sticky top-0 z-50 bg-[#FAFAFA]/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <a href="#" className="text-xl font-bold text-[#0F172A] tracking-tight">
              rtneg<span className="text-[#3B82F6]">.com</span>
            </a>
          </div>
          <nav className="hidden md:flex space-x-8">
            <a href="#projects" className="text-sm font-medium hover:text-[#3B82F6] transition-colors">
              {t('nav.projects')}
            </a>
            <a href="#about" className="text-sm font-medium hover:text-[#3B82F6] transition-colors">
              {t('nav.about')}
            </a>
          </nav>
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 text-sm font-medium bg-white border border-gray-200 px-3 py-1.5 rounded-full hover:border-[#3B82F6] hover:text-[#3B82F6] transition-all"
            >
              <Globe className="w-4 h-4" />
              <span>{i18n.language === 'en' ? '日本語' : 'English'}</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
